export interface ISwishResponse {
  error: boolean;
  redirectUrl: string;
  swishUrl: string;
  transactionId: string;
  errorMessage?: string;
}

export interface PollResponse {
  status: PaymentStatus;
  redirectUrl: string;
}

export enum PaymentStatus {
  Pending,
  Failed,
  Success,
  TimedOut,
}
